import { render, staticRenderFns } from "./newsletter-card.vue?vue&type=template&id=5c42e357&"
import script from "./newsletter-card.vue?vue&type=script&lang=js&"
export * from "./newsletter-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports